export enum NavigationEnum {
  Document = "document",
  CustomersList = "customer",
  PersonsList = "persons",
  CompaniesList = "companies",
  Warnings = "warnings",
  AdverseMediaList = "adverse-media",
  SanctionsList = "sanctions",
  PoliticalInvolvementsList = "political-involvements",
  DelegationSelector = "delegation"
}
